import _ from 'lodash';
import Vue from 'vue';
import { createActionHelpers } from 'vuex-loading';
import { searchTaxonomyByValue } from '@/utils';
import clientService from './service';

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading',
});

export const UPDATE_ERROR = 'UPDATE_ERROR';
export const CLEAR_MODULE = 'CLEAR_MODULE';
export const UPDATE_OPERATION = 'UPDATE_OPERATION';
export const RESTORE_CLIENTS = 'RESTORE_CLIENTS';
export const REPLACE_CLIENT = 'REPLACE_CLIENT';
export const ADD_DUMMY_CLIENT = 'ADD_DUMMY_CLIENT';
export const REMOVE_DUMMY_CLIENT = 'REMOVE_DUMMY_CLIENT';
export const REMOVE_CLIENT = 'REMOVE_CLIENT';
export const ADD_CONTACT = 'ADD_CONTACT';
export const REMOVE_CONTACT = 'REMOVE_CONTACT';
export const ADD_REPUTACION = 'ADD_REPUTACION';
export const REMOVE_REPUTACION = 'REMOVE_REPUTACION';
export const UPDATE_TIPOS_PERSONA = 'UPDATE_TIPOS_PERSONA';
export const UPDATE_TIPOS_ESTADO_CIVIL = 'UPDATE_TIPOS_ESTADO_CIVIL';
export const UPDATE_SEARCHING_CONTACTS = 'UPDATE_SEARCHING_CONTACTS';
export const UPDATE_SEARCHING_CLIENTS = 'UPDATE_SEARCHING_CLIENTS';
export const UPDATE_SEARCHED_CLIENTS = 'UPDATE_SEARCHED_CLIENTS';
export const UPDATE_SEARCHED_CONTACTS = 'UPDATE_SEARCHED_CONTACTS';
export const UPDATE_LOADING = 'UPDATE_LOADING';
export const CHANGE_TIPO_CLIENT = 'CHANGE_TIPO_CLIENT';
export const UPDATE_CLIENT_OPERATIONS = 'UPDATE_CLIENT_OPERATIONS';
export const ADD_CLIENT_OPERATIONS = 'ADD_CLIENT_OPERATIONS';
export const UPDATE_FLAG_CREATED = 'UPDATE_FLAG_CREATED';

export const ADD_DOCUMENT = 'ADD_DOCUMENT';
export const UPDATE_DOCUMENT = 'UPDATE_DOCUMENT';
export const DELETE_DOCUMENT = 'DELETE_DOCUMENT';

export default {
  namespaced: true,
  state: {
    error: '',
    loading: {
      client: false,
      contact: false,
      reputations: false,
    },
    currentClient: 0,
    totalClients: 0,
    clients: [],
    clientsData: {},
    contactsData: {},
    reputations: {},
    reputationsData: {},
    searchedClients: [],
    searchingClients: false,
    searchedContacts: [],
    searchingContacts: false,
    tiposPersona: [],
    tiposEstadoCivil: [],
    operation: null,
    clientOperations: {},
    documents: [],
  },
  mutations: {
    [ADD_DOCUMENT](state, payload) {
      state.documents.push(payload);
    },
    [UPDATE_DOCUMENT](state, payload) {
      const { index, document } = payload;
      state.documents.splice(index, 1, document);
    },
    [DELETE_DOCUMENT](state, payload) {
      state.documents.splice(payload, 1);
    },
    [UPDATE_ERROR](state, error) {
      state.error = error;
    },
    [CLEAR_MODULE](state) {
      state.error = '';
      state.loading = {
        client: false,
        contact: false,
        reputations: false,
      };
      state.clients = [];
      state.clientsData = {};
      state.contactsData = {};
      state.reputations = {};
      state.reputationsData = {};
      state.searchedClients = [];
      state.searchingClients = false;
      state.clientOperations = {};
      state.searchedContacts = [];
      state.searchingContacts = false;
      state.tiposPersona = [];
      state.tiposEstadoCivil = [];
    },
    [UPDATE_OPERATION](state, value) {
      state.operation = value;
    },
    [UPDATE_LOADING](state, payload) {
      const { key, value } = payload;
      state.loading[key] = value;
    },
    [RESTORE_CLIENTS](state, list) {
      state.clients = [];
      state.clientsData = {};
      list.forEach((client) => {
        state.clients.push(client.id);
        state.clientsData[client.id] = client;
        if (client.contact) {
          state.contactsData[client.id] = client.contact;
        } else {
          state.contactsData[client.id] = { id: 'dummy' };
        }
        if (client.reputations && client.reputations.length > 0) {
          state.reputations[client.id] = client.reputations.map(r => r.id);
          state.reputationsData[client.id] = client.reputations;
        } else {
          state.reputations[client.id] = ['dummy'];
          state.reputationsData[client.id] = [{ id: 'dummy' }];
        }
      });
    },
    [ADD_DUMMY_CLIENT](state, payload) {
      const { tipo } = payload;
      if (!state.clientsData.dummy) {
        state.clients.unshift('dummy');
        state.clientsData.dummy = { id: 'dummy', tipo };
        state.contactsData.dummy = { id: 'dummy' };
        state.reputations.dummy = ['dummy'];
        state.reputationsData.dummy = [{ id: 'dummy' }];
      }
    },
    [REMOVE_DUMMY_CLIENT](state) {
      const index = state.clients.indexOf('dummy');
      if (index > -1) {
        state.clients.splice(index, 1);
        delete state.clientsData.dummy;
        delete state.contactsData.dummy;
        delete state.reputations.dummy;
        delete state.reputationsData.dummy;
      }
    },
    [REPLACE_CLIENT](state, payload) {
      const contact = payload.client.contacto;
      const reputations = payload.client.reputations;
      const { client, index } = payload;
      if (state.clientsData[state.clients[index]]) {
        state.clientsData[client.id] = client;
        if (contact) {
          state.contactsData[client.id] = contact;
        } else {
          state.contactsData[client.id] = { id: 'dummy' };
        }
        if (reputations && reputations.length > 0) {
          state.reputations[client.id] = reputations.map(r => r.id);
          state.reputationsData[client.id] = reputations;
          state.clientsData[client.id].reputations = reputations;
        } else {
          state.reputations[client.id] = ['dummy'];
          state.reputationsData[client.id] = [{ id: 'dummy' }];
        }
        if (state.clients[index] !== client.id) {
          delete state.clientsData[state.clients[index]];
          delete state.contactsData[state.clients[index]];
          delete state.reputationsData[state.clients[index]];
          delete state.reputations[state.clients[index]];
        }
        state.clients.splice(index, 1, client.id);
      }
    },
    [REMOVE_CLIENT](state, client) {
      const index = state.clients.indexOf(client.id);
      if (index > -1) {
        delete state.clientsData[client.id];
        delete state.contactsData[client.id];
        delete state.reputationsData[client.id];
        delete state.reputations[client.id];
        state.clients.splice(index, 1);
      }
    },
    [ADD_CONTACT](state, payload) {
      const { client, contact } = payload;
      const clientToChange = state.clientsData[client.id];
      if (clientToChange) {
        state.clientsData[clientToChange.id] = clientToChange;
        state.contactsData[clientToChange.id] = contact;
        state.clients = Object.keys(state.clientsData);
      }
    },
    [REMOVE_CONTACT](state, client) {
      const clientToChange = state.clientsData[client.id];
      if (clientToChange) {
        state.clientsData[clientToChange.id] = clientToChange;
        state.contactsData[clientToChange.id] = { id: 'dummy' };
        state.clients = Object.keys(state.clientsData);
      }
    },
    [ADD_REPUTACION](state, payload) {
      const { client, reputations } = payload;
      const clientToChange = state.clientsData[client.id];
      if (clientToChange) {
        state.clientsData[clientToChange.id] = clientToChange;
        if (state.reputations[clientToChange.id].indexOf('dummy') < 0) {
          state.reputations[clientToChange.id].push('dummy');
        //  Vue.set(state.reputations, clientToChange.id, 'dummy');
        }
       // state.reputationsData[clientToChange.id] = reputations;
        Vue.set(state.reputationsData, clientToChange.id, reputations);
      //  state.clientsData[clientToChange.id].reputations = state.reputationsData[clientToChange];
         // Vue.set(state.clientsData[clientToChange.id], reputations, state.reputationsData[clientToChange]);
        let test = Object.keys(state.clientsData);
        test = test.reverse();
        Vue.set(state, 'clients', test);
        Vue.set(state, 'reputations', state.reputations);
        state.clientsData[client.id].reputations = state.reputationsData[clientToChange.id];
      }
    },
    [REMOVE_REPUTACION](state, payload) {
      const { client, index } = payload;
      const clientToChange = state.clientsData[client.id];
      if (clientToChange) {
        const reputationToRemove = state.reputations[clientToChange.id][index];
        state.reputations[clientToChange.id] = state.reputations[clientToChange.id].filter(id => id !== reputationToRemove);
        state.reputationsData[clientToChange.id] = state.reputationsData[clientToChange.id].filter(r => r.id !== reputationToRemove);
        state.clientsData[client.id].reputations = state.reputationsData[clientToChange.id];
      }
    },
    [UPDATE_TIPOS_PERSONA](state, lista) {
      state.tiposPersona = lista;
    },
    [UPDATE_TIPOS_ESTADO_CIVIL](state, lista) {
      state.tiposEstadoCivil = lista;
    },
    [UPDATE_SEARCHING_CLIENTS](state, newValue) {
      state.searchingClients = newValue;
    },
    [UPDATE_SEARCHED_CLIENTS](state, lista) {
      state.searchedClients = lista;
    },
    [UPDATE_SEARCHING_CONTACTS](state, newValue) {
      state.searchingContacts = newValue;
    },
    [UPDATE_SEARCHED_CONTACTS](state, lista) {
      state.searchedContacts = lista;
    },
    [UPDATE_CLIENT_OPERATIONS](state, lista) {
      state.clientOperations = lista;
    },
    [ADD_CLIENT_OPERATIONS](state, lista) {
      state.clientOperations.push(lista);
    },
    [UPDATE_FLAG_CREATED](state, payload) {
      state.flagCreated = payload;
    },
  },
  actions: {
    clearModuleAction({ commit }) {
      commit(CLEAR_MODULE);
    },
    initModuleActions({ commit, dispatch }, payload) {
      startLoading(dispatch, 'cliente');
      const { list, operation } = payload;
      commit(UPDATE_OPERATION, operation);
      commit(UPDATE_CLIENT_OPERATIONS, []);
      const promises = [];
      if (list && list.length > 0) {
        dispatch('getOperationsClientAction', list);
        list.forEach(client => promises.push(dispatch('getClientAction', client)));
        if (promises.length === 0) {
          return dispatch('addDummyClientAction');
        }
        return Promise.all(promises).then(() => {
          endLoading(dispatch, 'cliente');
        });
      }
      return endLoading(dispatch, 'cliente');
    },
    getClientAction({ commit, state, dispatch }, client) {
      startLoading(dispatch, 'cliente get');
      return clientService.getCliente(client)
        .then((result) => {
          if (state.clients.indexOf(result.id) < 0) {
            dispatch('addDummyClientAction');
            endLoading(dispatch, 'cliente get');
            return commit(REPLACE_CLIENT,
              {
                client: result,
                contact: result.contacto || { id: 'dummy' },
                reputations: result.reputations || { id: 'dummy' },
                index: state.clients.indexOf('dummy'),
              });
          }
          endLoading(dispatch, 'cliente get');
          return commit(REPLACE_CLIENT,
            {
              client: result,
              contact: result.contacto || { id: 'dummy' },
              reputations: result.reputations || { id: 'dummy' },
              index: state.clients.indexOf(result.id),
            });
        });
    },
    getOperationsClientAction({ commit, dispatch }, list) {
      const promises = [];
      if (list && list.length) {
        list.forEach((client) => {
          promises.push(clientService.searchOperationsByClient(client.id));
        });
      } else {
        promises.push(clientService.searchOperationsByClient(list.id));
      }
      Promise.all(promises)
       .then((data) => {
         const operations = Object.assign({}, ...data);
         commit(UPDATE_CLIENT_OPERATIONS, operations);
       });
    },
    addDummyClientAction({ commit, rootGetters }) {
      const tipo = rootGetters['taxonomy/searchTaxonomyValue']({ vid: 'person', text: 'Física' });
      commit(ADD_DUMMY_CLIENT, { tipo });
     // endLoading(dispatch, 'cliente');
    },
    saveClientAction({ commit, dispatch, rootGetters }, payload) {
      startLoading(dispatch, 'save client');
      const { client } = payload;
      commit(UPDATE_LOADING, { key: 'client', value: true });
      return clientService.getCliente(client)
        .then(() => clientService.updateCliente(client)
          .then(responseClient => dispatch('getClientAction', responseClient))
          .then(() => commit(UPDATE_LOADING, { key: 'client', value: false }))
          .catch((error) => {
            if (error.response.status === 403) {
              commit(UPDATE_ERROR, 'No tienes permisos');
            } else {
              commit(UPDATE_ERROR, 'Error en el servicio');
            }
          }))
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            return clientService.saveCliente(client)
              .then(responseClient => dispatch('getClientAction', responseClient))
              .then(() => commit(UPDATE_LOADING, { key: 'client', value: false }))
              .catch(() => commit(UPDATE_ERROR, 'Error al guardar el cliente'));
          }
          commit(UPDATE_LOADING, { key: 'client', value: false });
          return commit(UPDATE_ERROR, error.message);
        })
        .then(() => {
          if (payload.notOp) {
            endLoading(dispatch, 'save client');
            return;
          }
          const idOp = rootGetters.getOpid;
          if (idOp && idOp.length > 0) {
            endLoading(dispatch, 'save client');
            // eslint-disable-next-line consistent-return
            return dispatch('updateOperationAction', { id: rootGetters.getOpid });
          }
          endLoading(dispatch, 'save client');
        });
    },
    searchClientByNameAction({ commit, dispatch }, name) {
      commit(UPDATE_SEARCHING_CLIENTS, true);
      commit(UPDATE_SEARCHED_CLIENTS, []);
      return clientService.searchClientByName(name)
        .then((lista) => {
          dispatch('getOperationsClientAction', lista);
          commit(UPDATE_SEARCHING_CLIENTS, false);
          commit(UPDATE_SEARCHED_CLIENTS, lista);
        })
        .catch(() => {
          commit(UPDATE_SEARCHING_CLIENTS, false);
        });
    },
    searchClientBySurnameAction({ commit, dispatch }, name) {
      commit(UPDATE_SEARCHING_CLIENTS, true);
      commit(UPDATE_SEARCHED_CLIENTS, []);
      return clientService.searchClientBySurname(name)
        .then((lista) => {
          dispatch('getOperationsClientAction', lista);
          commit(UPDATE_SEARCHING_CLIENTS, false);
          commit(UPDATE_SEARCHED_CLIENTS, lista);
        })
        .catch(() => {
          commit(UPDATE_SEARCHING_CLIENTS, false);
        });
    },
    searchClientByDNIAction({ commit, dispatch }, payload) {
      const { dni, index } = payload;
      commit(UPDATE_SEARCHING_CLIENTS, true);
      commit(UPDATE_SEARCHED_CLIENTS, []);
      return clientService.getExistedDNI(dni)
        .then((lista) => {
          commit(UPDATE_SEARCHING_CLIENTS, false);
          commit(UPDATE_SEARCHED_CLIENTS, lista);
          if (lista && Object.keys(lista).length > 0) {
            dispatch('getOperationsClientAction', lista)
              .then(() => commit(REPLACE_CLIENT, { client: lista, index }));
          } else {
            commit(UPDATE_ERROR, 'No se ha encontrado el cliente para el DNI especificado.');
          }
        })
        .catch(() => {
          commit(UPDATE_SEARCHING_CLIENTS, false);
        });
    },
    replaceClientAction({ commit }, payload) {
      commit(REPLACE_CLIENT, payload);
    },
    removeClientAction({ commit, dispatch, rootGetters }, client) {
      commit(REMOVE_CLIENT, client);
      dispatch('updateOperationAction', { id: rootGetters.getOpid });
    },
    searchContactByDNIAction({ commit }, payload) {
      const { dni, client } = payload;
      commit(UPDATE_SEARCHING_CONTACTS, true);
      commit(UPDATE_SEARCHED_CONTACTS, []);
      return clientService.getExistedContactoDNI(dni)
        .then((lista) => {
          commit(UPDATE_SEARCHING_CONTACTS, false);
          commit(UPDATE_SEARCHED_CONTACTS, lista);
          if (lista && lista.length > 0) {
            commit(ADD_CONTACT, { client, contact: lista[0] });
          }
        })
        .catch(() => {
          commit(UPDATE_SEARCHING_CLIENTS, false);
        });
    },
    searchContactByNameAction({ commit }, name) {
      commit(UPDATE_SEARCHING_CONTACTS, true);
      commit(UPDATE_SEARCHED_CONTACTS, []);
      return clientService.searchContactoByName(name)
        .then((lista) => {
          commit(UPDATE_SEARCHING_CONTACTS, false);
          commit(UPDATE_SEARCHED_CONTACTS, lista);
        });
    },
    searchContactBySurnameAction({ commit }, name) {
      commit(UPDATE_SEARCHING_CONTACTS, true);
      commit(UPDATE_SEARCHED_CONTACTS, []);
      return clientService.searchContactoBySurname(name)
        .then((lista) => {
          commit(UPDATE_SEARCHING_CONTACTS, false);
          commit(UPDATE_SEARCHED_CONTACTS, lista);
        });
    },
    addContactToClientAction({ dispatch, commit }, payload) {
      const { client, contact } = payload;
      commit(UPDATE_LOADING, { key: 'contact', value: true });
      return clientService.getCliente(client)
        .then(c => clientService.saveClienteContacto(c, contact))
        .then((newCliente) => {
          commit(UPDATE_LOADING, { key: 'contact', value: false });
          return dispatch('getClientAction', newCliente);
        })
        // .then(() => commit(UPDATE_LOADING, { key: 'contact', value: false }))
        .catch((error) => {
          if (error.status && error.status === 404) {
            commit(UPDATE_ERROR, 'Cliente no encontrado');
            throw error;
          }
          commit(UPDATE_ERROR, error);
          commit(UPDATE_LOADING, { key: 'contact', value: false });
          throw error;
        });
    },
    updateContactAction({ dispatch, commit }, payload) {
      const { client, contact } = payload;
      if (contact.id !== 'dummy') {
        commit(UPDATE_LOADING, { key: 'contact', value: true });
        return clientService.updateContacto(contact)
          .then(() => {
            commit(UPDATE_LOADING, { key: 'contact', value: false });
            return dispatch('getClientAction', client);
          });
      }
      return dispatch('addContactToClientAction', payload);
    },
    replaceContactAction({ commit }, payload) {
      commit(ADD_CONTACT, payload);
    },
    addReputacionToClientAction({ commit, dispatch }, payload) {
      const { client, reputation } = payload;
      startLoading(dispatch, 'save reputation');
      let reputationSaved = null;
      // commit(UPDATE_LOADING, { key: 'reputation', value: true });
      return clientService.getCliente(client)
        .then(c => clientService.saveClienteReputation(c, reputation))
        .then((newCliente) => {
          if (_.isArray(newCliente.reputations) && newCliente.reputations.length > 0) {
            reputationSaved = newCliente.reputations[newCliente.reputations.length - 1];
          }
          // return dispatch('getClientAction', newCliente);
          endLoading(dispatch, 'save reputation');
          return reputationSaved;
        })
        // .then(() => commit(UPDATE_LOADING, { key: 'reputation', value: false }))
        .catch((error) => {
          if (error.status && error.status === 404) {
            commit(UPDATE_ERROR, 'Cliente no encontrado');
            throw error;
          }
          commit(UPDATE_ERROR, error);
          endLoading(dispatch, 'save reputation');
          // commit(UPDATE_LOADING, { key: 'reputation', value: false });
          throw error;
        });
    },
    updateReputationAction({ dispatch, commit }, payload) {
      startLoading(dispatch, 'save reputation');
      const { reputation } = payload;
      if (reputation.id !== 'dummy') {
        // commit(UPDATE_LOADING, { key: 'reputation', value: true });
        return clientService.updateReputation(reputation)
          // .then(() => dispatch('getClientAction', client))
          .then(() => endLoading(dispatch, 'save reputation'));
      }
      return dispatch('addReputacionToClientAction', payload);
    },
    removeReputationAction({ commit, getters, dispatch }, payload) {
      const { client } = payload;
      // commit(UPDATE_LOADING, { key: 'reputation', value: true });
      commit(REMOVE_REPUTACION, payload);
      return clientService.updateCliente(getters.client(client.id))
        .then(newClient => dispatch('getClientAction', newClient))
        // .then(() => commit(UPDATE_LOADING, { key: 'reputation', value: false }))
        .catch(() => commit(UPDATE_ERROR, 'Error al borrar la reputación'));
    },
    addDummyReputationAction({ commit, state }, payload) {
      const { client } = payload;

      const reputations = state.reputationsData[client.id].filter(r => r.id !== 'dummy');
      reputations.push({ id: 'dummy' });
      commit(ADD_REPUTACION, { client, reputations });
    },
    updateErrorAction({ commit }, error) {
      commit(UPDATE_ERROR, error);
    },
    updateOperationAction({ dispatch, state }, payload) {
      const clients = [];
      state.clients.forEach((c) => {
        if (c !== 'dummy') {
          clients.unshift(c);
        }
      });
      const operation = {
        id: payload.id,
        clients,
      };
      return dispatch('operation-tab/saveOperationAction', operation, { root: true });
      // return operationService.updateOperation(operation);
      //  .then(op => dispatch('operation/initOperationAction', op.id, { root: true })); */
    },
  },
  getters: {
    existDummy: state => state.clients.indexOf('dummy') > -1,
    existClient: state => id => state.clientsData[id] !== undefined,
    getClientIndex: state => client => state.clients.indexOf(client.id),
    countClients(state) {
      return state.clients.filter(c => c !== 'dummy').length;
    },
    clientList: state => state.clients,
    clientListData: state => state.clients.map(id => state.clientsData[id]),
    client: state => id => state.clientsData[id],
    contact: state => id => state.contactsData[id],
    reputation: (state, getters, rootState, rootGetters) => (payload) => {
      const reputation = state.reputationsData[payload.cliente][payload.reputation];
      const documents = rootGetters['documents/operationDocuments'];
      if (Array.isArray(documents)) {
        const document = documents.filter(doc => doc.id === reputation.document)[0];
        if (document) {
          return _.merge({}, reputation, { document });
        }
      }
      return reputation;
    },
    getReputations: state => state.reputations,
    reputations: state => id => state.reputationsData[id],
    reputationList: state => id => state.reputations[id],
    showRemoveReputation: state => (id) => {
      if ((state.reputations[id].indexOf('dummy')) >= 0 && (state.reputations[id].length === 1)) {
        return true;
      }
      return false;
    },
    existDummyReputation: state => id => state.reputations[id].indexOf('dummy') > -1,
    showAddReputation: (state, getters) => (payload) => {
      if (getters.existDummyReputation(payload.cliente)) {
        return false;
      }
      if (state.reputations[payload.cliente].indexOf(payload.reputation) === (state.reputations[payload.cliente].length - 1)) {
        return true;
      }
      return false;
    },
    error: state => state.error,
    existError: state => state.error !== '',
    getTipoClient: state => (id) => {
      const cliente = state.clients.find(c => c.id === id);
      return cliente ? cliente.tipo : null;
    },
    isPersonaFisica: (state, getters) => (id) => {
      const fisicaValue = searchTaxonomyByValue(state.tiposPersona, 'Física').value;
      return getters.getTipoClient(id) === fisicaValue;
    },
    isPersonaJuridica: (state, getters) => id => !getters.isPersonaFisica(id),
    searchedClients: state => state.searchedClients,
    isSearchingClient: state => state.searchingClients,
    searchedContacts: state => state.searchedContacts,
    isSearchingContact: state => state.searchingContacts,
    tiposPersona: state => state.tiposPersona,
    tiposEstadoCivil: state => state.tiposEstadoCivil,
    isLoading: state => id => state.loading[id],
    clientOperations: state => state.clientOperations,
    documents: state => state.documents,
    clientsData: state => state.clientsData,
  },
};



// WEBPACK FOOTER //
// ./src/features/tab-cliente/store.js